



































































































import {Component, Vue, Watch, Ref} from "vue-property-decorator"
import DatePicker from "@/components/DatePicker.vue"
import {vxm} from "@/store"
import {NotificationSummary} from "@/interface"
import moment from "moment"

@Component({components: {DatePicker}})
export default class ReportNotification extends Vue {

  private start_at: string = ""
  private end_at: string = ""
  private sort: string = "date"
  private sort_direct: string = "DESC"

  private loading: boolean = false

  @Ref("download") private download_button!: HTMLAnchorElement

  get notifications(): NotificationSummary[] {
    return vxm.report.notification_summaries
  }

  async mounted() {
    await this.load()
  }

  async onClickSort(type: string) {
    if (this.sort === type) {
      this.sort_direct = this.sort_direct === "ASC" ? "DESC" : "ASC"
    } else {
      this.sort = type
      this.sort_direct = "DESC"
    }
    await this.load()
  }

  async onClickDownload(type: string) {

    const site = vxm.app.sites.find(site => site.id === vxm.app.selected_site_id) || null
    const content = (type === "tsv")
      ? await vxm.report.getDownloadData("\t", false)
      : await vxm.report.getDownloadData()
      , blob      = new Blob([content], {"type": "text/plain"})
      , file_name = `NOTIFICATIONS_DATA-${site?.domain}.${type}`
    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveBlob(blob, file_name)
      window.navigator.msSaveOrOpenBlob(blob, file_name)
    } else {
      this.download_button.download = file_name
      this.download_button.href = window.URL.createObjectURL(blob)
      this.download_button.click()
    }
  }

  created() {
    this.start_at = moment().subtract(3, 'months').format('YYYY-MM-DD')
  }

  async load() {
    this.loading = true
    await vxm.report.fetchNotificationSummaries({
      force      : true,
      start_at   : this.start_at ? moment(this.start_at).unix() : undefined,
      end_at     : this.end_at ? moment(this.end_at).unix() : undefined,
      sort       : this.sort,
      sort_direct: this.sort_direct
    })
    this.loading = false
  }

  @Watch("start_at")
  @Watch("end_at")
  async watchStartAt() {

    // 開始より終了が前だったらスワップ
    if (this.start_at && this.end_at) {
      const start = moment(this.start_at)
        , end     = moment(this.end_at)
      if (start.isValid() && end.isValid() && start.isAfter(end)) {
        this.start_at = end.format("YYYY-MM-DD")
        this.end_at = start.format("YYYY-MM-DD")
      }
    }

    await this.load()
  }
}
